import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { 
  FaHome, 
  FaArrowLeft, 
  FaSearch,
  FaHeart,
  FaStar
} from 'react-icons/fa';
import '../../assets/css/general/notfound/Error.css';

const Error = () => {
  const navigate = useNavigate();

  // Handle Navigation
  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="nf-not-found-page">
      <Container>
        <Row className="nf-content-row">
          <Col lg={12}>
            {/* Animated Background Elements */}
            <div className="nf-background-elements">
              <div className="nf-floating-heart nf-heart-1">
                <FaHeart />
              </div>
              <div className="nf-floating-heart nf-heart-2">
                <FaHeart />
              </div>
              <div className="nf-floating-heart nf-heart-3">
                <FaHeart />
              </div>
              <div className="nf-floating-star nf-star-1">
                <FaStar />
              </div>
              <div className="nf-floating-star nf-star-2">
                <FaStar />
              </div>
              <div className="nf-floating-star nf-star-3">
                <FaStar />
              </div>
            </div>

            {/* Main Content */}
            <div className="nf-main-content">
              {/* 404 Number */}
              <div className="nf-error-number">
                <span className="nf-number-4 nf-number-first">4</span>
                <span className="nf-number-0">
                  <div className="nf-heart-container">
                    <FaHeart className="nf-heart-icon" />
                  </div>
                </span>
                <span className="nf-number-4 nf-number-last">4</span>
              </div>

              {/* Heading */}
              <h1 className="nf-error-heading">
                Oops! Page Not Found
              </h1>

              {/* Subtitle */}
              <p className="nf-error-subtitle">
                The page you're looking for seems to have wandered off, 
                just like a bride before her big day!
              </p>

              {/* Description */}
              <p className="nf-error-description">
                Don't worry, we'll help you find your way back to planning 
                the perfect celebration. 💍✨
              </p>

              {/* Decorative Divider */}
              <div className="nf-divider">
                <span className="nf-divider-icon">💐</span>
              </div>

              {/* Action Buttons */}
              <div className="nf-action-buttons">
                <Button 
                  className="nf-btn nf-btn-primary"
                  onClick={handleGoHome}
                >
                  <FaHome className="nf-btn-icon" />
                  Back to Home
                </Button>
                <Button 
                  className="nf-btn nf-btn-secondary"
                  onClick={handleGoBack}
                >
                  <FaArrowLeft className="nf-btn-icon" />
                  Go Back
                </Button>
              </div>

              {/* Search Suggestion */}
              <div className="nf-search-suggestion">
                <FaSearch className="nf-search-icon" />
                <p className="nf-search-text">
                  Try using the search bar or navigation menu to find what you need
                </p>
              </div>

              {/* Footer Note */}
              <div className="nf-footer-note">
                <p className="nf-footer-text">
                  Need help? Contact our <a href="/contact" className="nf-footer-link">support team</a>
                </p>
              </div>
            </div>

            {/* Decorative Elements */}
            <div className="nf-decorative-circles">
              <div className="nf-circle nf-circle-1"></div>
              <div className="nf-circle nf-circle-2"></div>
              <div className="nf-circle nf-circle-3"></div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Error;